import {Box3, Vector3} from "three";
import {toFixedFloat, toFixedVector} from "../../../../utils/utils";
import {HBEWallDefaultThickness} from "../../../../globals";

export class Room {
    constructor(identifier, object) {
        this.identifier = identifier;
        this.object = object;
        this.bounds = new Box3().setFromObject(object);

        //Y-Koordinate nicht relevant
        this.bounds.min.y = 0;
        this.bounds.max.y = 0;

        this.bounds.min = toFixedVector(this.bounds.min);
        this.bounds.max = toFixedVector(this.bounds.max);

        this.size = toFixedVector(this.bounds.getSize(new Vector3()));

        //Spannweite entspricht der Breite der Bounds (Innenkanten des Raums) + Einer Wandstärke (Halbe Wandstärke Auflagefläche pro Seite)
        this.spans = {
            x: toFixedFloat(this.size.x + HBEWallDefaultThickness),
            z: toFixedFloat(this.size.z + HBEWallDefaultThickness)
        };
    }

    canCombineWith(otherRoom) {
        return this.bounds.intersectsBox(otherRoom.bounds);
    }

    // Function to combine two rooms
    combineWith(otherRoom) {
        // Merge bounds
        this.bounds.union(otherRoom.bounds);

        // Update size and spans
        this.size = toFixedVector(this.bounds.getSize(new Vector3()));
        this.spans = {
            x: toFixedFloat(this.size.x + HBEWallDefaultThickness),
            z: toFixedFloat(this.size.z + HBEWallDefaultThickness)
        };

        // Update other properties as needed
    }
}
